import { useState } from 'react'
import { supabase } from '@/lib/supabase'

async function callBilling(path: string): Promise<string> {
  const { data } = await supabase.auth.getSession()
  const token = data.session?.access_token
  const res = await fetch(path, {
    method: 'POST',
    headers: { Authorization: 'Bearer ' + token },
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok || !json.url) throw new Error(json.error || 'Something went wrong')
  return json.url as string
}

/** Athlete billing actions: start a subscription or open the Stripe portal. */
export function useBilling() {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const go = async (path: string) => {
    setBusy(true)
    setError(null)
    try {
      window.location.href = await callBilling(path)
    } catch (e) {
      setError((e as Error).message)
      setBusy(false)
    }
  }

  return {
    busy,
    error,
    subscribe: () => go('/api/stripe-checkout'),
    manage: () => go('/api/stripe-portal'),
  }
}
